'use client';

import { useEffect } from 'react';
import { injectLeadfeeder } from '@/lib/analytics/leadfeeder';

export default function Leadfeeder() {
  useEffect(() => {
    void injectLeadfeeder();
  }, []);

  return null;
}
